import { type App, AppLogo, cn } from "@teamworksdev/react";
import type { HTMLAttributes, PropsWithChildren } from "react";

type IconBadgeProps = PropsWithChildren<
  {
    variant?: Variant;
    size?: number;
  } & HTMLAttributes<HTMLDivElement>
>;

type Variant = "info" | "warning" | "error" | "success" | "disabled";

export const IconBadge = ({ variant = "info", children, className, size, ...htmlAttributes }: IconBadgeProps) => {
  return (
    <div
      style={size ? { width: size, height: size, borderWidth: size / 4 / 2 } : undefined}
      className={cn(
        "box-content border-[1.5px] rounded-full w-3 h-3", // size and shape
        "flex items-center justify-center", // center content
        className,
        {
          "border-info-200": variant === "info",
          "border-warning-200": variant === "warning",
          "border-error-200": variant === "error",
          "border-success-200": variant === "success",
          "border-light-300": variant === "disabled",
        },
      )}
      {...htmlAttributes}
    >
      {children}
    </div>
  );
};

IconBadge.displayName = "IconBadge";

export const AppLogoWithIconBadge = ({
  app,
  variant,
  children,
  ...htmlAttributes
}: {
  app: App;
  variant: Variant;
} & HTMLAttributes<HTMLDivElement>) => {
  return (
    <div className="relative" {...htmlAttributes}>
      <AppLogo app={app} variant="black" />
      <IconBadge className="absolute -bottom-[1.5px] -right-[5px]" variant={variant}>
        {children}
      </IconBadge>
    </div>
  );
};

AppLogoWithIconBadge.displayName = "AppLogoWithIconBadge";
